module.exports = __webpack_public_path__ + "static/img/icon_class_drone.29122c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_class_drone.png
// module id = A8A6
// module chunks = 1